import { IoCloseOutline } from "react-icons/io5";
import Link from "next/link";
import { createLabelForFilters, deleteFilter } from "./utils";

export const ActiveFilters = ({ filters, fullUrl }) => {
  if (filters.length > 0) {
    return (
      <div className="mb-5 bg-white rounded-lg shadow-lg w-full border">
        <div className="font-bold bg-blue-800 text-white p-2 rounded rounded-b-none text-center">
          <h4 className="text-sm">Filtros aplicados</h4>
        </div>
        <div className="p-2">
          {filters.map((filter) => (
            <Link key={filter} href={deleteFilter(fullUrl, filter)}>
              <div className="flex flex-row justify-between items-center gap-4">
                <div>{createLabelForFilters(filter)}</div>
                <div className="text-red-500 text-lg font-semibold">
                  <IoCloseOutline />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    );
  }
  return <></>;
};
